"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const lib_env_1 = __importDefault(require("@opsbase/lib-env"));
const DeviceType_1 = __importDefault(require("@opsbase/lib-general/DeviceType"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_self_1 = __importDefault(require("@opsbase/lib-self"));
const lib_storage_1 = require("@opsbase/lib-storage");
const aws_amplify_1 = __importDefault(require("aws-amplify"));
const axios_1 = __importDefault(require("axios"));
const platform_1 = __importDefault(require("platform"));
aws_amplify_1.default.configure({
    Auth: {
        region: lib_env_1.default.cognito.region,
        identityPoolId: lib_env_1.default.cognito.identityPoolId,
        userPoolId: lib_env_1.default.cognito.userPoolId,
        userPoolWebClientId: lib_env_1.default.cognito.userPoolWebClientId,
    },
});
const getHeader = (headers, key) => {
    if (headers.get) {
        return (headers.get(key) || '').split('Bearer ').join('');
    }
    else {
        return (headers[key] || '').split('Bearer ').join('');
    }
};
function getResponseAuthTokens(headers) {
    const a = getHeader(headers, 'authorization'), b = getHeader(headers, 'x-amzn-remapped-authorization'), c = getHeader(headers, 'refresh-token'), d = getHeader(headers, 'x-amzn-remapped-refresh-token');
    return {
        accessToken: !!a ? a : b,
        refreshToken: !!c ? c : d,
    };
}
function hasAuthHeaders() {
    if ((0, lib_storage_1.getStoredValue)('shadowAccessToken'))
        return true;
    if ((0, lib_storage_1.getStoredValue)('shadowRefreshToken'))
        return true;
    if ((0, lib_storage_1.getStoredValue)('accessToken'))
        return true;
    return !!(0, lib_storage_1.getStoredValue)('refreshToken');
}
function getRequestAuthHeaders(forceReal = false) {
    const shadowAccessToken = (0, lib_storage_1.getStoredValue)('shadowAccessToken');
    const shadowRefreshToken = (0, lib_storage_1.getStoredValue)('shadowRefreshToken');
    const accessToken = (0, lib_storage_1.getStoredValue)('accessToken');
    const refreshToken = (0, lib_storage_1.getStoredValue)('refreshToken');
    const isShadowing = !forceReal && !!shadowAccessToken;
    return {
        opsbaseapp: 'web',
        opsbaseappversion: platform_1.default.description,
        authorization: isShadowing ? shadowAccessToken : accessToken,
        'refresh-token': isShadowing ? shadowRefreshToken : refreshToken,
    };
}
function handleHttpResponseHeaders(headers, forceReal = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const shadowAccessToken = (0, lib_storage_1.getStoredValue)('shadowAccessToken');
        const shadowRefreshToken = (0, lib_storage_1.getStoredValue)('shadowRefreshToken');
        const accessToken = (0, lib_storage_1.getStoredValue)('accessToken');
        const refreshToken = (0, lib_storage_1.getStoredValue)('refreshToken');
        const isShadowing = !forceReal && !!shadowAccessToken;
        const tokens = getResponseAuthTokens(headers);
        if (tokens.accessToken && tokens.refreshToken) {
            if (isShadowing) {
                if (shadowAccessToken != tokens.accessToken ||
                    shadowRefreshToken != tokens.refreshToken) {
                    (0, lib_storage_1.setStoredValue)('shadowAccessToken', tokens.accessToken);
                    (0, lib_storage_1.setStoredValue)('shadowRefreshToken', tokens.refreshToken);
                }
            }
            else {
                if (accessToken != tokens.accessToken || refreshToken != tokens.refreshToken) {
                    (0, lib_storage_1.setStoredValue)('accessToken', tokens.accessToken);
                    (0, lib_storage_1.setStoredValue)('refreshToken', tokens.refreshToken);
                }
            }
        }
    });
}
function doSignout() {
    return __awaiter(this, void 0, void 0, function* () {
        (0, lib_storage_1.removeStoredValue)('accessToken');
        (0, lib_storage_1.removeStoredValue)('refreshToken');
        (0, lib_storage_1.removeStoredValue)('shadowAccessToken');
        (0, lib_storage_1.removeStoredValue)('shadowRefreshToken');
        (0, lib_storage_1.removeStoredValue)('self');
        (0, lib_storage_1.removeStoredValue)('realSelf');
    });
}
exports.Auth = {
    getRequestAuthHeaders,
    handleHttpResponseHeaders,
    hasAuthHeaders,
    api: {
        reloadSelf: (forceReal = false) => __awaiter(void 0, void 0, void 0, function* () {
            const r = yield retryGet(3, `${lib_env_1.default.apis.auth}/whoami/${DeviceType_1.default.WEBAPP}`, {
                headers: Object.assign({}, getRequestAuthHeaders(forceReal)),
            });
            yield handleHttpResponseHeaders(r.headers, forceReal);
            return lib_self_1.default.fromData(r.data);
        }),
        signOut: doSignout,
        otpSignIn: (app, id, passKey) => __awaiter(void 0, void 0, void 0, function* () {
            return axios_1.default
                .post(`${lib_env_1.default.apis.auth}/app/user/signin`, {
                app,
                id,
                passKey,
            })
                .then(handleDataResponse)
                .catch(handleError);
        }),
        shadow: (staffId, organisationId) => __awaiter(void 0, void 0, void 0, function* () {
            return axios_1.default
                .post(`${lib_env_1.default.apis.auth}/app/staff/shadow`, { staffId, organisationId }, {
                headers: Object.assign({}, getRequestAuthHeaders()),
            })
                .then(handleSelfResponse)
                .catch(handleError);
        }),
        shadowTeamboard: (teamboardId, organisationId) => __awaiter(void 0, void 0, void 0, function* () {
            return axios_1.default
                .post(`${lib_env_1.default.apis.auth}/app/staff/shadowTeamboard`, { teamboardId, organisationId }, {
                headers: Object.assign({}, getRequestAuthHeaders()),
            })
                .then(handleSelfResponse)
                .catch(handleError);
        }),
        passKey: (app, identifier) => __awaiter(void 0, void 0, void 0, function* () {
            return axios_1.default
                .post(`${lib_env_1.default.apis.auth}/app/user/passkey`, {
                app,
                identifier,
            })
                .then(handleDataResponse)
                .catch(handleError);
        }),
        teamboardSignin: (app, passKey) => __awaiter(void 0, void 0, void 0, function* () {
            return axios_1.default
                .post(`${lib_env_1.default.apis.auth}/app/teamboard/signin`, {
                app,
                passKey,
            })
                .then(handleDataResponse)
                .catch(handleError);
        }),
    },
};
exports.default = exports.Auth;
function retryGet(noOfRetries, uri, options) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            axios_1.default
                .get(uri, options)
                .then(resolve)
                .catch((err) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                if (((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                    yield doSignout();
                    return reject(err);
                }
                if (noOfRetries <= 0) {
                    yield doSignout();
                    return reject(err);
                }
                setTimeout(() => {
                    retryGet(noOfRetries - 1, uri, options)
                        .then(resolve)
                        .catch(() => __awaiter(this, void 0, void 0, function* () {
                        yield doSignout();
                        return reject();
                    }));
                }, 1500);
            }));
        });
    });
}
function handleDataResponse({ headers, data }) {
    return __awaiter(this, void 0, void 0, function* () {
        handleHttpResponseHeaders(headers).catch(doNothing_1.default);
        return data;
    });
}
function handleSelfResponse(r) {
    return __awaiter(this, void 0, void 0, function* () {
        if (r.status !== 200) {
            throw new Error(lib_i18n_1.default.t('error-auth-signup'));
        }
        return {
            self: r.data,
            accessToken: r.headers['shadow-access-token'],
            refreshToken: r.headers['shadow-refresh-token'],
        };
    });
}
function handleError(e) {
    return __awaiter(this, void 0, void 0, function* () {
        if (e === null || e === void 0 ? void 0 : e.response) {
            throw new Error(e.response.data.message);
        }
        if (e === null || e === void 0 ? void 0 : e.message) {
            throw new Error(e.message);
        }
        yield doSignout();
        throw new Error('Unexpected problem signing in');
    });
}
